<script setup lang="ts">
import TableFooterBar from '@/components/bars/TableFooterBar.vue';
import KBtn from '@/components/btns/KBtn.vue';
import ZammadTicketDetailsUnit from '@/components/units/ZammadTicketDetailsUnit.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
</script>

<template>
  <div :class="$style.zammadTicketPageView" data-testid="zammadTicketPageView">
    <PageContentWrapper>
      <ZammadTicketDetailsUnit />
      <h2> Some Ticket Subject </h2>
      <div :class="$style.messages"> messages </div>
    </PageContentWrapper>
    <TableFooterBar>
      <KBtn size="lg" append-icon="mdi-reply" class="mr-4"> Reply </KBtn>
      <KBtn size="lg" variant="outlined" append-icon="mdi-close">
        Close ticket
      </KBtn>
    </TableFooterBar>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.zammadTicketPageView {
}
</style>
